import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import Dialog from '@mui/material/Dialog';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import cx from 'classnames';
import ViewTaskModalDetail from './ViewTaskModalDetail';

class ViewTaskModal extends Component {
    // Keep one ref per task/dialogue so it stays stable across renders
    nodeRefs = new Map();
    getNodeRef = diagId => {
        if (!this.nodeRefs.has(diagId)) {
            this.nodeRefs.set(diagId, React.createRef());
        }
        return this.nodeRefs.get(diagId);
    };
    PaperComponent = (props, task, diagId) => {
        const nodeRef = this.getNodeRef(diagId);
        return (
            <Draggable
                key={diagId}
                nodeRef={nodeRef}
                handle={`#${diagId}`}
                cancel={'[class*="MuiDialogContent-root"]'}
                bounds="body"
            >
                <Paper ref={nodeRef} {...props} />
            </Draggable>
        );
    };
    handleClose = diagId => {
        const { onClose } = this.props;
        this.nodeRefs.delete(diagId);
        onClose && onClose();
    };

    render() {
        const { classes, open, task } = this.props;
        if (!(task && !!task.node && !!open)) return null;
        const diagId = `ViewTaskModal-${task ? task.node.ID : 'X'}`;
        const onClose = () => this.handleClose(diagId);
        return (
            <Dialog
                className={cx(classes.root, 'workqueue-page', 'draggable-root')}
                open={open}
                PaperComponent={props => this.PaperComponent(props, task, diagId)}
                BackdropProps={{
                    invisible: true,
                    style: {
                        pointerEvents: 'none' // allow clicking on background!
                    }
                }}
                onClose={onClose}
                aria-labelledby={diagId}
            >
                <ViewTaskModalDetail dragHandle={diagId} task={task} onClose={onClose} />
            </Dialog>
        );
    }
}

const styles = ({ breakpoints, palette }) => ({
    root: {
        pointerEvents: 'none',
        '& > :nth-child(2)': {
            pointerEvents: 'none',
            '& > div': {
                borderRadius: 12,
                border: '3px solid ' + palette.primary.main,
                pointerEvents: 'auto',
                overflow: 'hidden',
                maxHeight: '94vh',
                [breakpoints.down('sm')]: {
                    margin: 6
                }
            }
        }
    }
});

export default withStyles(styles)(ViewTaskModal);
